import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ILovsReducer } from './types';

const initialState: ILovsReducer = {
  currency: [],
  relatedCompanies: []
};

const lovsSlice = createSlice({
  name: 'lovs',
  initialState: initialState,
  reducers: {
    LoadLovs(state, action: PayloadAction<any>) {
      state = {
        ...action.payload
      };

      return state;
    }
  }
});

export const { LoadLovs } = lovsSlice.actions;

const lovsReducer = lovsSlice.reducer;
export default lovsReducer;
